import React from "react";
import "./ComingSoonPageRes.css";
import Icon from "../../assets/images/surgeIconPurple.svg";

function ComingSoonPageRes(props) {
  return (
    <div>
      <div className="ComingSoonPageContainer">
        <img
          src={Icon}
          alt=""
          style={{
            height: "180px",
          }}
        ></img>

        <p
          style={{
            color: "white",
            fontSize: "22px",
            width: "80%",
            fontWeight: 500,
          }}
        >
          {props.text}
        </p>
        <div>
          <div
            className="apple_button"
            style={{ padding: "10px", alignItems: "center" }}
          >
            <img
              src={window.location.origin + "/appleLogo.svg"}
              className="brand_logo apple_logo"
            ></img>
            <div
              className="col"
              onClick={() =>
                window.location.assign(
                  "https://apps.apple.com/us/app/surge-playlist-for-parties/id1643038656"
                )
              }
            >
              <a className="signin_text" style={{ fontSize: 9 }}>
                Download on the
              </a>
              <a className="signin_text" style={{ fontSize: 13 }}>
                AppStore
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoonPageRes;
